var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { value: Boolean(_vm.value), persistent: "", "max-width": "560" },
    },
    [
      _vm.value
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.value.title))]),
              _c(
                "v-card-text",
                [
                  _vm._v(" " + _vm._s(_vm.value.message) + " "),
                  _vm.technicalDetails.length
                    ? _c(
                        "v-expansion-panels",
                        { staticClass: "mt-4", attrs: { flat: "" } },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c("v-expansion-panel-header", [
                                _vm._v("Technical details"),
                              ]),
                              _c(
                                "v-expansion-panel-content",
                                _vm._l(_vm.technicalDetails, function (detail) {
                                  return _c("div", { key: detail.label }, [
                                    _c("strong", [
                                      _vm._v(_vm._s(detail.label) + ":"),
                                    ]),
                                    _vm._v(" " + _vm._s(detail.value) + " "),
                                  ])
                                }),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm.value.applicationId
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "white--text",
                          attrs: { color: "#006c27" },
                          on: {
                            click: function ($event) {
                              return _vm.$emit(
                                "open-application",
                                _vm.value.applicationId
                              )
                            },
                          },
                        },
                        [_vm._v(" Open application ")]
                      )
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { color: "#006c27" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("close")
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }